import { Page, View, Image, Text, Link } from '@react-pdf/renderer';
import { styles } from './styles';
import bgImage from '@assets/images/bg_speakers.png';
import {
  Portfolio,
  PublicEventDetailsResponse,
  ResponsePaginationType,
} from '@hubs101/booking-api-skd-client/lib/types';
import { useTranslation } from 'react-i18next';
import { APP_HOST } from '@utils/apiHooks';
import { SafeImage } from '../../components/SafeImage';

export interface IncreaseYourSalesProps {
  event: PublicEventDetailsResponse;
  coLocatedEvents: PublicEventDetailsResponse[] | undefined;
  portfolios: ResponsePaginationType<Portfolio> | undefined;
  header: JSX.Element;
  footer: JSX.Element;
}

const IncreaseYourSales = ({
  event,
  coLocatedEvents,
  portfolios,
  header,
  footer,
}: IncreaseYourSalesProps) => {
  const { t } = useTranslation();

  return (
    <Page size="A4" orientation="portrait" style={styles.page}>
      <View style={styles.backgroundContainer}>
        <SafeImage
          src={
            'https://media.we-conect.com/images/pdf/agenda/pdf_agenda_increase_hero.jpg'
          }
          style={styles.backgroundImage}
          debugLabel="agenda-increase-background"
        />

        <View>{header}</View>

        <View style={styles.overlayContent}>
          <Text style={styles.title}>
            {t('you-want-to-increase-your-sales')}
          </Text>
          <View
            style={{
              ...styles.lineBar,
            }}
          ></View>
        </View>
      </View>

      <View
        style={{
          ...styles.contentWrapper,
        }}
      >
        {[1, 2, 3, 4, 5].map(index => {
          return (
            <View
              key={`increase-your-sales-item-${index}`}
              style={styles.itemWrapper}
            >
              <Text style={styles.boldText}>
                {t(`increase-your-sales-title-${index}`)}
              </Text>
              <Text style={styles.text}>
                {t(`increase-your-sales-paragraph-${index}`)}
              </Text>
            </View>
          );
        })}
      </View>

      <View style={styles.downloadThePartnerBrochureWrapper}>
        <SafeImage
          style={styles.downloadImage}
          src={bgImage}
          debugLabel="increase-your-sales"
        />
        <Text style={styles.downloadThePartnerBrochureTitle}>
          {t('become-a-partner')}
        </Text>
        <Text style={styles.downloadThePartnerBrochureText}>
          {t('get-ready-for-the-event-of-the-year')}
        </Text>

        <View style={styles.downloadThePartnerBrochureButtonWrapper}>
          <Link
            src={`${APP_HOST}/events/${event?.slug}/business-partner.pdf`}
            style={styles.downloadThePartnerBrochureButton}
          >
            {t('download-the-partner-brochure')}
          </Link>
        </View>
      </View>

      {footer}
    </Page>
  );
};

export default IncreaseYourSales;
